var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbassadorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9874,
    cy: 4.91965,
    rx: 3.8443,
    ry: 3.91965,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9606 16.3127C17.6157 14.8755 17.2198 13.2424 16.8239 11.4524C16.6451 10.6685 16.0193 10.0805 15.3296 10.0674C14.8059 10.0674 14.2695 10.0674 13.7459 10.0674C12.9924 10.8122 12.0472 11.3217 11 11.3217C9.95267 11.3217 9.00756 10.8122 8.25403 10.0674C7.73039 10.0674 7.19397 10.0674 6.67033 10.0674C5.96788 10.0805 5.35484 10.6685 5.17604 11.4524C4.76734 13.2293 4.38419 14.8625 4.03935 16.3127C3.835 17.1881 4.44804 18.756 5.38038 19.3831C8.82876 21.5389 13.1967 21.5389 16.6578 19.3831C17.5519 18.756 18.1649 17.1751 17.9606 16.3127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbassadorIcon);
export default __webpack_public_path__ + "static/media/ambassador_icon.18e8b58d506f0ed249a767b76947cc6d.svg";
export { ForwardRef as ReactComponent };